"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const storage_handler_1 = require("@ebay-business-components/favorites-utils/dist/utils/browser/storage-handler");
const tracking_handler_1 = require("@ebay-business-components/favorites-utils/dist/utils/browser/tracking-handler");
const constants_1 = require("@ebay-business-components/favorites-utils/dist/constants");
const constants_2 = require("../../constants");
class WatchHandler extends Marko.Component {
    onInput(input) {
        this.state = {
            snackbar: {
                content: '',
                open: false,
                actionLinkText: '',
            },
            isWatched: false,
            isError: false,
            responseType: '',
        };
        this.watchDataProvider = input.watchDataProvider;
    }
    onMount() {
        this.subscribeTo(document).on(constants_2.EVENTS.HANDLE_WATCH_ACTION, this.handleWatchActionEvent.bind(this));
        const parsedSessionData = (0, storage_handler_1.processSessionData)(constants_2.SESSION_STORAGE);
        if (parsedSessionData) {
            this.handleWatchAction(parsedSessionData);
        }
    }
    handleWatchActionEvent(event) {
        const { ADD_ACTION, REMOVE_ACTION } = constants_1.WATCH_ACTION;
        const { itemDetails, trackingData } = event.detail;
        const { itemData } = itemDetails || {};
        const watchAction = itemData.isWatched ? REMOVE_ACTION : ADD_ACTION;
        const data = { watchData: itemDetails, watchAction, trackingData };
        (0, tracking_handler_1.handleTracking)(trackingData, itemData, watchAction);
        this.handleWatchAction(data);
    }
    onSnackbarClose() {
        this.state.snackbar.open = false;
        this.state.snackbar.content = '';
        this.state.snackbar.actionLinkText = '';
        this.state.isError = false;
        this.state.responseType = '';
    }
    handleWatchAction(data) {
        return __awaiter(this, void 0, void 0, function* () {
            let response;
            const { ADD_ACTION, REMOVE_ACTION } = constants_1.WATCH_ACTION;
            const { addToWatchHandler, removeFromWatchHandler } = this.watchDataProvider;
            const { watchAction, watchData, trackingData } = data;
            switch (watchAction) {
                case ADD_ACTION:
                    response = yield addToWatchHandler(watchData, {}, trackingData);
                    this.handleResponse(response);
                    break;
                case REMOVE_ACTION:
                    response = yield removeFromWatchHandler(watchData, {}, trackingData);
                    this.handleResponse(response);
                    break;
                default:
                    console.error(`Invalid watch action: ${watchAction}`);
                    break;
            }
        });
    }
    handleResponse(response) {
        var _a, _b;
        if (response && 'redirectURL' in response) {
            this.emit(constants_2.EVENTS.WATCH_UPDATE_HANDLER, {
                redirectURL: response.redirectURL,
            });
        }
        else {
            const { status = 'ERROR', type = '', message = '', additionalMessage = '', } = response;
            if (status === 'SUCCESS') {
                this.state.isWatched =
                    type === constants_2.RESPONSE_TYPES.ADD_TO_WATCH_LIST_SUCCESS;
                const customEvent = new CustomEvent(constants_2.EVENTS.UPDATE_WATCH_STATUS, {
                    detail: {
                        watchResponse: response,
                    },
                });
                document.dispatchEvent(customEvent);
            }
            else {
                if (message) {
                    this.state.snackbar.content = message;
                }
                else {
                    this.state.snackbar.content =
                        ((_b = (_a = this.input) === null || _a === void 0 ? void 0 : _a.localizedContent) === null || _b === void 0 ? void 0 : _b.error) || constants_2.MESSAGES.ERROR;
                }
                this.state.isError = true;
                this.state.snackbar.open = true;
                if (type === constants_2.RESPONSE_TYPES.CSRF_TOKEN_ERROR ||
                    type === constants_2.RESPONSE_TYPES.WATCH_LIST_FULL) {
                    this.state.snackbar.actionLinkText = additionalMessage;
                }
            }
            this.emit(constants_2.EVENTS.WATCH_UPDATE_HANDLER, Object.assign(Object.assign({ isWatched: this.state.isWatched }, (response && response.listId
                ? { listId: response.listId }
                : {})), (response && response.listName
                ? { listName: response.listName }
                : {})));
            if ((0, storage_handler_1.getSessionData)(constants_2.SESSION_STORAGE) !== null) {
                (0, storage_handler_1.clearSessionData)(constants_2.SESSION_STORAGE);
            }
            this.state.responseType = type;
        }
    }
}
exports.default = WatchHandler;
